import React from 'react'
import { history } from '../store'

class PDAList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filters: { code: '', customer: '' },
      inputValues: { code: '', customer: '' },
      filterOpen: true,
      showButton: false,
      buttonPosition: { x: 0, y: 0 },
      selectedId: null,
    };

    this.debounceTimer = null;
  }

  goTo(id, e) {
    history.push(`/pdas/${id}`)
  }

  handleFilterChange(filterKey, value) {
    // Debounce text inputs
    this.setState(prev => ({ inputValues: { ...prev.inputValues, [filterKey]: value } }));
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.setState(prev => ({ filters: { ...prev.filters, [filterKey]: value } }));
    }, 400);
  }

  toggleFilter = () => this.setState(prev => ({ filterOpen: !prev.filterOpen }));
  clearFilters = () => this.setState({ filters: { code: '', customer: '' }, inputValues: { code: '', customer: '' } });

  componentWillUnmount() { if (this.debounceTimer) clearTimeout(this.debounceTimer); }

  render() {
    const { filters, inputValues } = this.state;
    const { pdas } = this.props;

    const filteredpdas = pdas.filter(pda => {
      const { code: codeFilter, customer: customerFilter } = filters;
      if (codeFilter && (!pda.Code || !pda.Code.toLowerCase().includes(codeFilter.toLowerCase()))) return false;
      if (customerFilter && (!pda.Customer.Fullname || !pda.Customer.Fullname.toLowerCase().includes(customerFilter.toLowerCase()))) return false;
      return true;
    });

    return (
      <div>
        {/* Filters — admin only */}
        {this.props.role === 'ADMIN' && (
        <div className="pdas-admin-filter-card">
          <div className="pdas-admin-filter-header" onClick={this.toggleFilter}>
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${this.state.filterOpen ? 'open' : ''}`}></i>
          </div>

          {this.state.filterOpen && (
            <div className="pdas-admin-filter-body">
              <div className="filter-grid">
                <div className="filter-group">
                  <label>Código</label>
                  <input value={inputValues.code} onChange={e => this.handleFilterChange('code', e.target.value)} placeholder="Code" />
                </div>
                <div className="filter-group">
                  <label>Cliente</label>
                  <input value={inputValues.customer} onChange={e => this.handleFilterChange('customer', e.target.value)} placeholder="Cliente" />
                </div>
                <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end' }}>
                  <button type="button" className="btn btn-light" onClick={this.clearFilters}>Limpiar</button>
                </div>
              </div>
            </div>
          )}
        </div>
        )}

        {/* Header */}
        <div className="pdas-admin-list-header">
          <div className="pdas-header-col col-id">Código</div>
          <div className="pdas-header-col col-customer">Cliente</div>
          <div className="pdas-header-col col-token">SN Dispositivo</div>
          <div className="pdas-header-col col-sales">Ventas</div>
          <div className="pdas-header-col col-actions">Acciones</div>
        </div>

        {/* Cards */}
        <div className="pdas-admin-list">
          {filteredpdas.map(pda => (
            <div key={pda._id} className="pdas-admin-card" onClick={e => this.goTo(pda._id, e)}>
              <div className="pdas-admin-row">
                <div className="pdas-admin-content">
                  <div className="pdas-admin-machine-id"><div className="pdas-admin-code">{pda.Code}</div></div>
                  <div className="pdas-admin-machine-customer"><div className="pdas-admin-customer-name">{pda.Customer?.Fullname || '-'}</div></div>
                  <div className="pdas-admin-machine-token"><div className="pdas-admin-sub">{pda.Token}</div></div>
                  <div className="pdas-admin-machine-sales"><div className="pdas-admin-sub">{pda.LastSale}</div></div>
                  <div className="pdas-admin-machine-actions">
                    <button className="pdas-admin-card-action-btn" onClick={(ev) => { ev.stopPropagation(); this.goTo(pda._id, ev); }}>
                      <i className="fas fa-eye"></i>
                      <span className="d-none d-sm-inline ml-1">Ver</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default PDAList